// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1nAEt","file":"styles_file__2GIDg"};